import React from 'react';
import styled from 'styled-components';

import { DiscountTag } from 'src/assets/discount-tag';

type ProgressProps = {
  progress: number;
};

export const Progress = ({ progress }: ProgressProps): JSX.Element => (
  <Wrapper>
    <OuterCircle $progress={progress}>
      <InnerCircle>
        <DiscountTag width={16} height={16} />
      </InnerCircle>
    </OuterCircle>
  </Wrapper>
);

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 38px;
  justify-content: center;
  width: 38px;
`;

const OuterCircle = styled.div<{ $progress: number }>`
  align-items: center;
  background: conic-gradient(#00624a ${({ $progress }) => $progress}%, #fff ${({ $progress }) => $progress}%);
  border-radius: 50%;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const InnerCircle = styled.div`
  align-items: center;
  background: #ceeedb;
  border-radius: 50%;
  color: #00624a;
  display: flex;
  height: 30px;
  justify-content: center;
  width: 30px;
`;
